import React, { useCallback, useEffect, useState } from 'react';
import { orarioSelected, quotaSelected, setIsResettedFilter } from 'features/sport/sportSlice';
import { useAppDispatch, useTypedSelector } from 'lib/centralStore';

import { ChipRadioButton } from 'components/inputs/chipRadioButton/ChipRadioButton';
import { RangeSlider } from 'components/inputs/rangeSlider';
import { selectSelectedFilter } from 'features/sport/selectors';
import { useGetLabelByKey } from 'hooks/useLingUI';
import { SportNavFiltersContainer } from 'features/sport/components/sportNav/sportNavFilters/sportNavFiltersContainer';
import styles from './SportNavFiltersContent.module.scss';
import { usePrematchFilters } from 'features/sport/components/sportNav/sportNavFilters/sportNavFiltersContent/hooks';

export type SportNavFiltersContentProps = {
  handleClose: React.Dispatch<React.SetStateAction<boolean>>;
};

export const SportNavFiltersContent = ({ handleClose }: SportNavFiltersContentProps) => {
  const dispatch = useAppDispatch();

  const { filters, sequence } = usePrematchFilters();

  const labelApplicaFiltri = useGetLabelByKey('prematch-filters-apply');

  const { orario: stOrario, quota: stQuota, isResetted } = useTypedSelector(selectSelectedFilter);

  const [quote, setQuote] = useState<number[]>(stQuota);
  const [orario, setOrario] = useState<string>(stOrario);

  const handleChangeQuota = useCallback((valueRange: number[]) => {
    setQuote(valueRange);
  }, []);

  const handleChangeOrario = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setOrario(e.target.value);
  }, []);

  useEffect(() => {
    setOrario(stOrario);
  }, [stOrario]);

  //TODO CHECK
  useEffect(() => {
    setQuote(stQuota);
  }, [stQuota]);

  const handleClickSubmit = useCallback(() => {
    dispatch(quotaSelected(quote));
    dispatch(orarioSelected(orario));
    dispatch(setIsResettedFilter(false));
    handleClose(false);
    // console.log('quote', quote);
  }, [dispatch, handleClose, orario, quote]);

  useEffect(() => {
    if (isResetted) {
      setQuote([1, 100]);
    }
  }, [isResetted]);

  return (
    <div className={styles.container}>
      <div className={styles.filtersContainer}>
        {sequence.map((name) => {
          const filter = filters[name];
          // eslint-disable-next-line react/jsx-no-useless-fragment
          let objContent = <React.Fragment />;

          switch (filter.type) {
            case 'range': {
              const value = filter.values[0];
              objContent = (
                <RangeSlider
                  min={value.range[0]}
                  max={value.range[1]}
                  step={value.step}
                  value={quote}
                  // name={filterQuota.name}
                  direction={value.direction}
                  isResetted={isResetted}
                  defaultValue={value.defaultValue}
                  onValueChange={handleChangeQuota}
                  onValueCommit={handleChangeQuota}
                />
              );
              break;
            }
            default: {
              objContent = (
                <ChipRadioButton
                  name={filter.description}
                  options={filter.values}
                  valueDefault={orario}
                  valueChecked={orario}
                  onChange={handleChangeOrario}
                  chipClassName={styles.chip}
                />
              );
              break;
            }
          }

          return (
            <SportNavFiltersContainer
              key={name}
              title={filter.name}
              tooltipContent={filter.description}
              hasBorderBottom
            >
              {objContent}
            </SportNavFiltersContainer>
          );
        })}
      </div>
      <div className={styles.footer}>
        <button type="button" className={styles.button} onClick={handleClickSubmit}>
          {labelApplicaFiltri}
        </button>
      </div>
    </div>
  );
};